/**
 * Redux middleware factory. Creates a redux middleware that catches exceptions
 * during the dispatching of actions and reports them to Bugsnag.
 * @param {object} bugsnagClient the configured bugsnagClient object
 * @returns {function} redux middleware
 */
const create = bugsnagClient => store => next => action => {
  try {
    return next(action);
  } catch (err) {
    const context = 'Error in Redux Action';
    const metadata = {
      action,
      state: store.getState().toJS(),
    };

    bugsnagClient.notify(err, { context, metadata });
  }

  return null;
};

const reduxMiddlewareFactory = { create };

export default reduxMiddlewareFactory;



// WEBPACK FOOTER //
// ./src/setup/BugSnag/reduxMiddlewareFactory.js